const service = function(C) {
  // assume no refresh needed on first load
  this.needToRefresh = false;

  this.setRevisionStatus = function(incomingRevision) {
    if (!incomingRevision) { return; }
    if (!C.GIT_REVISION) { return; }
    if (incomingRevision !== C.GIT_REVISION) {
      this.needToRefresh = true;
      // once the state change success happens and the refresh happens,
      // this will be reset to false by code loading
    }
  }

  this.needHardRefresh = function() {
    if (!this.needToRefresh) { return false; }

    // check that we have not already reloaded in the 30 min to avoid
    // any looping unpleasantness, hopefully
    let previous = localStorage.getItem('GitRevisionCheckSetNeedToRefresh')
    if (previous) {
      let parsed = JSON.parse(previous)
      if (parsed && parsed.timestamp &&
        (new Date().getTime() - parsed.timestamp) < 1000*60*10) {
        return false;
      }
    }
    return true;
  }

  this.doHardRefresh = function(url) {
    localStorage.setItem('GitRevisionCheckSetNeedToRefresh', JSON.stringify({
      timestamp: new Date().getTime()
    }))
    window.location.href = url
  };

  this.checkAndDoHardRefresh = function(url) {
    if (!this.needHardRefresh()) {
      return;
    }
    if (!url) { return; }
    this.doHardRefresh(url);
  }
}

service.$inject = ['C'];

tiz.service('GitRevisionCheck', service);
